module.exports = __webpack_public_path__ + "img/feilun.34e3bebd.png";